import { useProcessesObject } from 'store/process';
import { CommonTranslationKeys } from 'intl/keys';
import { localizeLabel } from 'helpers/misc';
import { createEntityFilterInput } from '../common';

export const ProcessFilterInput = createEntityFilterInput({
  useData: () => useProcessesObject(),
  transformData: (processes, intl) =>
    Object.values(processes).map((process) => ({
      _id: process._id,
      label: localizeLabel(intl, process.label),
    })),
  labelId: CommonTranslationKeys.process,
  id: 'process-filter',
});
